import { render, staticRenderFns } from "./paperCheckManage.vue?vue&type=template&id=16b0aad1&scoped=true"
import script from "./paperCheckManage.vue?vue&type=script&lang=js"
export * from "./paperCheckManage.vue?vue&type=script&lang=js"
import style0 from "./paperCheckManage.vue?vue&type=style&index=0&id=16b0aad1&prod&scoped=true&lang=less"
import style1 from "./paperCheckManage.vue?vue&type=style&index=1&id=16b0aad1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b0aad1",
  null
  
)

export default component.exports